<template>
    <v-container fluid>
        <h3>Отчеты по прошедшим вебинарам</h3>
        <v-dialog v-model="loader" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Загрузка
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="2">
                <v-select :items="emails" v-model="selectedEmails" multiple label="Аккаунты"
                          @change="getList"></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="2">
                <v-text-field v-model="dateFrom" label="Дата начала" type="date" @change="getList"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="2">
                <v-text-field v-model="dateTo" label="Дата окончания" type="date" @change="getList"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="2">
                <v-select :items="meetings" :disabled="meetings.length < 1" v-model="selectedMeetings" item-value="id" item-text="topic" return-object
                          multiple label="Список вебинаров">
                    <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                            <span>{{ item.topic }}</span>
                        </v-chip>
                        <span v-if="index === 1"
                              class="grey--text caption">и еще {{ selectedMeetings.length - 1 }}</span>
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn :disabled="selectedMeetings.length < 1" color="success" @click="getReports">Загрузить отчеты</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                    <v-combobox
                            v-model="nameMailFilter"
                            :items="[]"
                            label="Фильтр по имени или email"
                            placeholder="Введити имя или email и нажмите enter"
                            multiple
                            chips
                    ></v-combobox>
            </v-col>
            <v-col cols="12">
                <v-card-title>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Фильтровать результаты"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="shiftedReports"
                        :search="search"
                        item-key="hash"
                        multi-sort
                        group-by="meeting_topic"
                        :items-per-page="2000"
                        no-data-text="Нет данных. Заполните форму для поиска"
                        hide-default-footer
                >
                    <template v-slot:group.header="{ group, isOpen, toggle, items }">
                        <td class="yellow darken-2 pt-2 pb-2 font-weight-bold" :colspan="headers.length-1">
                        <v-btn icon @click="toggle"><v-icon v-html="!!isOpen ? `mdi-minus` : `mdi-plus`"></v-icon></v-btn>
                            {{ group }} | Участников: {{ items.length }}
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
  import moment from 'moment'

  export default {
    components: {},
    data: () => ({
      search: null,
      nameMailFilter: [],
      headers: [
        { text: 'Имя', value: 'name' },
        { text: 'Email', value: 'user_email' },
        { text: 'Вход', value: 'join_time' },
        { text: 'Выход', value: 'leave_time' },
        { text: 'Провел времени', value: 'duration' },
        { text: 'Вебинар', value: 'meeting_topic' },
      ],
      loader: false,
      emails: [
        'fitzoom@fitauto.ru',
        'fitzoom2@fitauto.ru',
        'fitzoom3@fitauto.ru',
        'fitzoom4@fitauto.ru',
        'fitzoom5@fitauto.ru',
      ],
      selectedEmails: [],
      selectedMeetings: [],
      meetings: [],
      reports: [],
      dateFrom: null,
      dateTo: null
    }),
    watch: {},
    computed: {
      shiftedReports() {
        if(this.nameMailFilter.length > 0) {
          let items = []
          for(let filt of this.nameMailFilter) {
            items = items.concat(this.reports.filter(item => item.name.toLowerCase().indexOf(filt.toLowerCase()) > -1 || item.user_email.toLowerCase().indexOf(filt.toLowerCase()) > -1))
          }
          return items
        } else {
          return this.reports
        }
      }
    },
    filters: {},
    methods: {
      async getList () {

        let dateDiff = moment(this.dateTo).diff(moment(this.dateFrom), 'days') >= 0
        let dfEmpty = this.dateDiff !== null
        let dtEmpty = this.dateTo !== null
        let emailsCount = this.selectedEmails.length > 0
        console.log('compare', {
          dateDiff,
          dfEmpty,
          dtEmpty,
          emailsCount
        })

        if (!!dateDiff && !!dfEmpty && !!dtEmpty && !!emailsCount) {
          this.loader = true
          console.log('get')
          let meetings = []
          for (let email of this.selectedEmails) {
            console.log('get iter:', email)
            try {
              const r = await this.$http.get(`${this.$store.getters.api}v4/zoom/meetengs/past?userid=${encodeURIComponent(email)}&from=${encodeURIComponent(this.dateFrom)}&to=${encodeURIComponent(this.dateTo)}`)
              if (!r.data.error) {
                r.data.meetings.forEach(m => {
                  meetings.push(m)
                })
              }
            } catch (e) {
              console.log('rep', e)
            }
          }
          console.log('meets', meetings)
          this.meetings = meetings
          this.loader = false
        } else {
          console.log('dont get!')
        }
      },
      async getReports () {
        let reports = []
        this.loader = true
        for (let meeting of this.selectedMeetings) {
            try {
              const r = await this.$http.get(`${this.$store.getters.api}v4/zoom/report/past/${meeting.id}`)
              if(!r.data.error) {
                r.data.participants.forEach(p => {
                  let item = p
                  item.meeting_id = meeting.id
                  item.meeting_topic = `${meeting.topic}. Начало вебинара в ${moment(meeting.start_time, "YYYY-MM-DDTkk:mm:ssZ").tz('Europe/Moscow').format('kk:mm')} по МСК | Длительность: ${meeting.duration} мин.`
                  item.meeting_start_time = meeting.start_time
                  item.meeting_end_time = meeting.end_time
                  item.meeting_duration = meeting.duration
                  item.meeting_participants_count = meeting.participants_count
                  item.hash = item.id + item.meeting_id + item.join_time
                  item.duration = moment(item.leave_time, "YYYY-MM-DDTkk:mm:ssZ").diff(moment(item.join_time, "YYYY-MM-DDTkk:mm:ssZ"), 'minutes')
                  item.join_time = moment(item.join_time, "YYYY-MM-DDTkk:mm:ssZ").tz('Europe/Moscow').format('kk:mm')
                  item.leave_time = moment(item.leave_time, "YYYY-MM-DDTkk:mm:ssZ").tz('Europe/Moscow').format('kk:mm')
                  reports.push(item)
                })
              }
            } catch (e) {
              console.log(e)
            }
        }
        this.loader = false
        this.reports = reports
        console.log('reps', reports)
      }
    },
    created () {
      this.$emit('maincomponenthooks', { hideAppBar: true })
    },
    async mounted () {

    },
  }
</script>
<style>

</style>
